import { Company } from "@authentic-labs/vue-component-library";

export const COMPANY_DETAIL_VIEWED_EVENT = "CompanyDetailPageViewed";
export const COMPANY_SECTION_VIEWED_EVENT = "CompanySectionViewed";
export const PRODUCT_DETAIL_VIEWED_EVENT = "ProductDetailPageViewed";
export const PRODUCT_SECTION_VIEWED_EVENT = "ProductSectionViewed";

type CompanyDetailEventArgs = {
  company: Company;
  companyId: number;
  duration: number;
};
export const companyDetailEventArgs: (
  company: Company,
  duration: number
) => CompanyDetailEventArgs = (company, duration) => {
  return { company, duration, companyId: company.companyId };
};
